export interface Duration {
  days: number;
  hours: number;
  minutes: number;
}

function getPrettyDuration(duration: Duration) {
  let prettyDuration = '';
  if (duration.days > 0) {
    prettyDuration += `${duration.days} days`;
  }
  if (duration.hours > 0) {
    prettyDuration += `${prettyDuration.length > 0 ? ', ' : ''}${
      duration.hours + duration.minutes / 60
    } hours`;
  }
  return prettyDuration;
}

export default getPrettyDuration;
